/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Charspage_Meta_DescInputs */

const en_fw_charspage_meta_desc = /** @type {(inputs: Fw_Charspage_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meet the Firefly Wedding characters: Satoko Kirigaya (Lynn), Shinpei Gotō (Kōki Uchiyama), Kōtarō Ogawa (Kento Itō), Mitsueda (Kenjirō Tsuda) and more.`)
};

const zh_fw_charspage_meta_desc = /** @type {(inputs: Fw_Charspage_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁角色介绍：桐ヶ谷紗都子（Lynn）、後藤進平（内山昂輝）、小川康太郎（伊東健人）、三枝（津田健次郎）等。`)
};

/**
* | output |
* | --- |
* | "Meet the Firefly Wedding characters: Satoko Kirigaya (Lynn), Shinpei Gotō (Kōki Uchiyama), Kōtarō Ogawa (Kento Itō), Mitsueda (Kenjirō Tsuda) and more." |
*
* @param {Fw_Charspage_Meta_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_charspage_meta_desc = /** @type {((inputs?: Fw_Charspage_Meta_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Charspage_Meta_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_charspage_meta_desc(inputs)
	return zh_fw_charspage_meta_desc(inputs)
});
export { fw_charspage_meta_desc as "fw.charspage.meta_desc" }